/**
 * HomePage — public homepage for The Archive (living-archive redesign, Jun 2026).
 *
 * Mobile-first discovery hierarchy:
 *   1. Hero (unchanged)            2. Live Archive status
 *   3. Latest Files                4. Featured Investigations
 *   5. Live in the Archive        6. Ask Oracle + Oracle Recommends
 *   7. What's Happening (tabs)    8. Explore the Archive (Subjects/Regions)
 *   9. Curated Collections       10. From the Archive
 *  11. Chain of the Week         12. Join the Archive
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import HeroSection from "../components/home/HeroSection";
import OperationsPulsePanel from "../components/home/OperationsPulsePanel";
import LatestFiles from "../components/home/LatestFiles";
import FeaturedDossiersGrid from "../components/home/FeaturedDossiersGrid";
import LiveInTheArchive from "../components/home/LiveInTheArchive";
import AskOracle from "../components/home/AskOracle";
import WhatsHappening from "../components/home/WhatsHappening";
import ExploreArchive from "../components/home/ExploreArchive";
import CuratedCollections from "../components/home/CuratedCollections";
import FromTheArchive from "../components/home/FromTheArchive";
import ChainOfTheWeek from "../components/home/ChainOfTheWeek";
import MembershipCTA from "../components/home/MembershipCTA";
import { ResumeInvestigationCard } from "../investigation/ResumeInvestigationCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HomePage = () => {
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/home/featured`, { timeout: 12000 });
        if (!cancelled) setPayload(data);
      } catch { /* silent — sections gracefully degrade */ }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div data-testid="home-page" style={{ background: "#0B0A0D" }} className="min-h-screen">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <ResumeInvestigationCard className="mt-4" />
      </div>
      <HeroSection />
      <OperationsPulsePanel />
      <LatestFiles />
      <FeaturedDossiersGrid featured={payload?.featured || []} />
      <LiveInTheArchive />
      <AskOracle />
      <WhatsHappening />
      <ExploreArchive />
      <CuratedCollections />
      <FromTheArchive />
      <ChainOfTheWeek />
      <MembershipCTA />
    </div>
  );
};

export default HomePage;
